// extracted by mini-css-extract-plugin
module.exports =  {"news":"NewsCard-UwBy__news","hide":"NewsCard-NpT8__hide","header-image":"NewsCard-XkU1__header-image","title":"NewsCard-D6jN__title"};